import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import { compose } from 'redux';

import type { UnifiedEvent } from 'src/app/analytics/analyticsEvents';
import { segmentTrack } from 'src/app/state/actions';
import type { Dispatch } from 'src/app/state/store';

import { DefaultPhoneRenderer } from '.';

/**
 * ### Inferring The Connected Props Automatically
 * @see https://react-redux.js.org/using-react-redux/static-typing#inferring-the-connected-props-automatically
 */
const connector = connect(null, (dispatch: Dispatch) => ({
  dispatchSegmentTrack: (event: UnifiedEvent, payload) => dispatch(segmentTrack(event, payload)),
}));
export type PropsFromRedux = ConnectedProps<typeof connector>;

export const DefaultPhoneNumber = compose(connector)(DefaultPhoneRenderer);
